import styled from "styled-components";
import { Modal } from "../../../design-system/components/composite/Modal/Modal";
import { Button } from "../../../design-system/components/primitives/Button/Button";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const ModalShell = styled(Modal)`
  width: min(62.5rem, 100%);
  border: ${({ theme }) => theme.borders.width[1]}
    ${({ theme }) => theme.borders.style.solid}
    ${({ theme }) => theme.colors.border.subtle};

  && {
    height: 35.5rem;
  }
`;

export const HeaderIdentity = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.base[2]};
`;

export const HeaderIcon = styled.span`
  display: inline-flex;
  flex: 0 0 ${({ theme }) => theme.spacing.base[7]};
  width: ${({ theme }) => theme.spacing.base[7]};
  height: ${({ theme }) => theme.spacing.base[7]};
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borders.radius.md};
  background: ${({ theme }) => theme.colors.background.tertiary};
  color: ${({ theme }) => theme.colors.text.interactive};

  svg {
    width: ${({ theme }) => theme.spacing.base[4]};
    height: ${({ theme }) => theme.spacing.base[4]};
  }
`;

export const HeaderText = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
`;

export const HeaderTitle = styled.h2`
  margin: 0;
  overflow: hidden;
  ${typographyMixin("body", 2)}
  color: ${({ theme }) => theme.colors.text.primary};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const HeaderMetadata = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  gap: calc(
    ${({ theme }) => theme.spacing.base[1]} +
      ${({ theme }) => theme.spacing.base[0.5]}
  );
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const MetadataText = styled.span<{ $separator?: boolean }>`
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: calc(
    ${({ theme }) => theme.spacing.base[1]} +
      ${({ theme }) => theme.spacing.base[0.5]}
  );
  ${typographyMixin("caption", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};
  white-space: nowrap;

  &::before {
    display: ${({ $separator }) => ($separator ? "block" : "none")};
    width: ${({ theme }) => theme.spacing.base[1]};
    height: ${({ theme }) => theme.spacing.base[1]};
    border-radius: ${({ theme }) => theme.borders.radius.full};
    background: ${({ theme }) => theme.colors.text.tertiary};
    content: "";
  }
`;

export const MetadataPill = styled.span`
  flex: 0 0 auto;
  padding: ${({ theme }) => theme.spacing.base[1]}
    calc(
      ${({ theme }) => theme.spacing.base[2]} +
        ${({ theme }) => theme.spacing.base[0.5]}
    );
  border-radius: ${({ theme }) => theme.borders.radius.full};
  background: ${({ theme }) => theme.colors.background.tertiary};
  ${typographyMixin("caption", 4)}
  color: ${({ theme }) => theme.colors.text.primary};
  white-space: nowrap;
`;

export const PanelsGrid = styled.div`
  display: grid;
  height: 100%;
  min-height: 0;
  min-width: 0;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${({ theme }) => theme.spacing.base[3]};

  ${({ theme }) => theme.breakpoints.mediaQueries.down.sm} {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const StateRegion = styled.div`
  display: flex;
  min-height: ${({ theme }) => theme.spacing.base[48]};
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.base[2]};
  ${typographyMixin("body", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const ErrorRegion = styled(StateRegion)`
  flex-direction: column;
  color: ${({ theme }) => theme.colors.error.text};
  text-align: center;
`;

export const UpdateError = styled.p`
  grid-column: 1 / -1;
  margin: 0;
  ${typographyMixin("caption", 4)}
  color: ${({ theme }) => theme.colors.error.text};
`;

export const UpdateButton = styled(Button)`
  width: 7.5rem;
`;
